<template>
    <div>
        <HeaderBreadcrumbs
            :items="[
                { label: 'Category AX' },
            ]"
            title="All Category AX"
        />
        <div class="bg-white rounded-lg shadow-sm">
            <div class="flex justify-between px-4 py-3 items-center  align-middle">
                <div class="block relative">
                    <svg class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                    <input class="bg-white rounded-lg py-2 px-11 border w-96"
                        placeholder='Search Name, Code' v-model="filter" @input="filterCategoryAX" />
                    <button
                    v-if="this.filter?.length"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>

                </div>
            </div>

            <div class="w-full">
                <TableCategoryAx :currentpage="currentPage" :perpage="perPage" :data="item"
                    :isLoading="isLoading" />
            </div>

            <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center mt-3">
                <div class="font-semibold">
                    <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
                        class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
                </div>
                <div class="mb-2">
                    <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
                        class="rounded-lg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TableCategoryAx from '../../components/microsoft365/table.vue';
// import DatetimeCustom from '../../components/form/Datetime.vue'
import HeaderBreadcrumbs from "@/components/HeaderBreadcrumbs.vue";

import moment from 'moment';
export default {
    name: "contentrequest",
    components: {
        TableCategoryAx,
        HeaderBreadcrumbs,
        // DatetimeCustom
    },
    computed: {
        ...mapState({
            //isError: (state) => state.coupons.isError,
            item: (state) => state.ax.items,
            totalRows: (state) => state.ax.totalRows,
            isLoading: (state) => state.ax.isLoading,
            errorMessage: (state) => state.ax.errorMessage,
            successMessage: (state) => state.ax.successMessage,
        }),
    },
    data() {
        return {
            name: "",
            currentPage: 1,
            perPage: 15,
            debounceTimer: null,
            created: "",
            filter: null,
            modified: ""
        }
    },
    watch: {
        currentPage() {
            this.fetchDataCategoryAx();
        },
    },
    mounted() {
        this.fetchDataCategoryAx();
    },

    methods: {
        ...mapActions("ax", [
            "fetchCategoryAx",
        ]),
        formatDate(tgl) {
            if (tgl) {
                return moment(tgl).format("DD MMMM YYYY HH:mm:ss");
            }
            return "-";
        },
        async fetchDataCategoryAx() {
            const payload = this.buildPayload(this.currentPage);
            await this.fetchCategoryAx(payload);
        },

        async filterCategoryAX() {
            const payload = this.buildPayload(this.currentPage = 1);
            await this.fetchCategoryAx(payload);
        },


        buildPayload(page) {
            const payload = {
                page,
                limit: this.perPage,
                search: this.filter?.trim(),
            };
            return payload;
        },
        actionReset() {
            this.filter = null
            this.fetchDataCategoryAx()
        },

    }
}

</script>
<style scoped>
.w-custom {
    width: 550px;
}
</style>
